import { createContext, useContext } from 'react';

/** Do not import for non Atlassian studio */
export const SiteContext = createContext({
	siteId: '',
});

/** Do not import for non Atlassian studio */
export const useSiteContext = () => {
	const context = useContext(SiteContext);

	return context;
};
